
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46404_93PaVTiigtdWcCyxGkK6KIxDxN2Dcy2nh_45xm9CDrtzjYkMeta } from "/var/www/production/website/pages/[...404].vue?macro=true";
import { default as about_45usPVYlNup74F8ccZUSTpZxBnui9Zal1ey9H216CBCId_45EMeta } from "/var/www/production/website/pages/about-us.vue?macro=true";
import { default as businessUaDz1bMyijq5iWSuvFgPf6d5zKERmhW7X_T4yUgzG9kMeta } from "/var/www/production/website/pages/business.vue?macro=true";
import { default as categoriesPHiPzzY30yr6_45Oa7MX5mpXtfvvvdZy44g9AVkLGgYYQMeta } from "/var/www/production/website/pages/categories.vue?macro=true";
import { default as _91slug_930ntA5VtmcX_8H3R9zHsSGnYDcbwTDnO6rL7LYvMNInYMeta } from "/var/www/production/website/pages/category/[id]/[slug].vue?macro=true";
import { default as contact_45us9Rna0jU4HrSm2PAKeB_45klflyGAZpX589w5PI_45UHWIaMMeta } from "/var/www/production/website/pages/contact-us.vue?macro=true";
import { default as expertsNvhSgn2smUT1IH_45KAvrtNbYTbnFa8bGe45BG4eyiDzIMeta } from "/var/www/production/website/pages/experts.vue?macro=true";
import { default as indexsXmNK7I4_45ckGIPIN_45YPIr3zJTHjzLDrfePWA1BgxWm0Meta } from "/var/www/production/website/pages/index.vue?macro=true";
import { default as _91slug_93DIs0G0vPmWLz0T9lZ_tbb54TIAis1VTlst_45qpFdRfD4Meta } from "/var/www/production/website/pages/place/[place_id]/[slug].vue?macro=true";
import { default as _91tenant_93OKEuMoh9rqDNVm5tCAiDqW6YnBt8cvt7OPPqJS_45TMQ8Meta } from "/var/www/production/website/pages/place/[tenant].vue?macro=true";
import { default as places93nRR2rYL7bL_45SaxmdkwN1k1d3YaCA_qn3u3_45QmnYr0Meta } from "/var/www/production/website/pages/places.vue?macro=true";
import { default as privacyfanbzXSPXdKX8ml3A1TASQBURPRS7FiXaOj1a0oTWAwMeta } from "/var/www/production/website/pages/privacy.vue?macro=true";
import { default as suggestkKThyqN9bDnfpaJRs4aRYmPhKbtF8QxNOfZJCnQo2FgMeta } from "/var/www/production/website/pages/suggest.vue?macro=true";
import { default as termsOpaAO2EOxPkhucAOdpF5QdK7_70JlL_anSVjzQXbWcYMeta } from "/var/www/production/website/pages/terms.vue?macro=true";
import { default as _91slug_93Nrb0v89NQEPkqwRfon_v40xoKsPS9AmNX6RD1PBVTxMMeta } from "/var/www/production/website/pages/user-profile/[user_id]/[slug].vue?macro=true";
import { default as my_45ratesBTx_45itDIqBT4mugTD01GIElzt7JGRlZqH2BZaIBEgIMMeta } from "/var/www/production/website/pages/user/my-rates.vue?macro=true";
import { default as profile7Lf2fpvqzswErEgfWbORNaJcFYbsEB0cpMp3h6IVaAEMeta } from "/var/www/production/website/pages/user/profile.vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/var/www/production/website/pages/[...404].vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/var/www/production/website/pages/about-us.vue")
  },
  {
    name: "business",
    path: "/business",
    component: () => import("/var/www/production/website/pages/business.vue")
  },
  {
    name: "categories",
    path: "/categories",
    component: () => import("/var/www/production/website/pages/categories.vue")
  },
  {
    name: "category-id-slug",
    path: "/category/:id()/:slug()",
    component: () => import("/var/www/production/website/pages/category/[id]/[slug].vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/var/www/production/website/pages/contact-us.vue")
  },
  {
    name: "experts",
    path: "/experts",
    component: () => import("/var/www/production/website/pages/experts.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/production/website/pages/index.vue")
  },
  {
    name: "place-place_id-slug",
    path: "/place/:place_id()/:slug()",
    component: () => import("/var/www/production/website/pages/place/[place_id]/[slug].vue")
  },
  {
    name: "place-tenant",
    path: "/place/:tenant()",
    component: () => import("/var/www/production/website/pages/place/[tenant].vue")
  },
  {
    name: "places",
    path: "/places",
    component: () => import("/var/www/production/website/pages/places.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/var/www/production/website/pages/privacy.vue")
  },
  {
    name: "suggest",
    path: "/suggest",
    component: () => import("/var/www/production/website/pages/suggest.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/var/www/production/website/pages/terms.vue")
  },
  {
    name: "user-profile-user_id-slug",
    path: "/user-profile/:user_id()/:slug()",
    component: () => import("/var/www/production/website/pages/user-profile/[user_id]/[slug].vue")
  },
  {
    name: "user-my-rates",
    path: "/user/my-rates",
    component: () => import("/var/www/production/website/pages/user/my-rates.vue")
  },
  {
    name: "user-profile",
    path: "/user/profile",
    component: () => import("/var/www/production/website/pages/user/profile.vue")
  }
]